export default function selectJiraSitesAreLoading(state, { source }) {
  return state.integrations.thirdPartyData[source].sites.loading
}
